export const ERROR_CURRENCY =
  'Invalid currency format. Enter a positive number with up to two decimal places.';
export const ERROR_GREATER_THAN_ZERO =
  'Value must be greater than or equal to 0';
export const ERROR_REQUIRED = 'A value is required';
export const ERROR_NUMBER = 'The value input must be a number';
export const ERROR_INTEGER = 'The value input must be a whole number';
export const ERROR_EMAIL = 'Enter a valid email';
export const ERROR_ZIP_CODE = 'Enter a valid Zip Code';

export const EROOR_MAXIMUM_VALUE = 'The value input must be a number';
export const ERROR_MIN_VALUE = (value: number) =>
  `The minimum value is ${value}`;
export const ERROR_MAX_VALUE = (value: number) =>
  `The maximum value is ${value}`;

export const FormValidations = {
  ERROR_CURRENCY,
  ERROR_EMAIL,
  ERROR_GREATER_THAN_ZERO,
  ERROR_INTEGER,
  ERROR_NUMBER,
  ERROR_REQUIRED,
  ERROR_ZIP_CODE,
};
